module.exports = __webpack_public_path__ + "img/1.64e69a03.png";